



























































































import { Input } from './mixins';
import { ValidationProvider } from 'vee-validate';
import { Component, Vue, Prop, Mixins, Emit, Watch } from 'vue-property-decorator';
import { State, Getter, Action } from 'vuex-class';
import { Drag, Drop, DropList } from 'vue-easy-dnd';
import { Debounce } from '@/functions/debounce';

@Component({
  components: {
    ValidationProvider,
    Drag,
    DropList,
    Drop,
    FormInput: () => import('@/components/forms/Input.vue'),
    FormButton: () => import('@/components/forms/Button.vue'),
    PartOverlay: () => import('@/layouts/parts/overlay.vue'),
  },
})
export default class FormSearchCollections extends Mixins(Input) {
  @Getter('workspace/selected') workspace!: Workspace;

  @Getter('collect/all') collects!: Collect[];

  @Action('collection/index') indexCollections!: (payload?: { query?: IndexQuery<Collection>; workspaceId: number }) => Promise<Collection[]>;

  @Prop({ default: '' }) readonly value!: string | number;

  searchString: string = '';

  open: boolean = false;

  searchedCollections: Collection[] = [];

  selectedCollections: Collection[] = [];

  selectedCollectionIds: number[] = [];

  created() {
    this.initialCollections();
  }

  private reorder(event: { from: number; to: number; apply: ([]) => void }) {
    event.apply(this.selectedCollections);
    this.updateCollections();
  }

  private toggleCollection(collection: Collection) {
    const foundCollection = this.selectedCollections.find((sCollection) => sCollection.id === collection.id);
    if (foundCollection === undefined) {
      this.selectedCollections.push(collection);
      this.updateCollections();
      return;
    }
    this.selectedCollections.splice(this.selectedCollections.indexOf(foundCollection), 1);
    this.updateCollections();
  }

  private handleInitialSearch() {
    if (this.searchString === '' || this.open) {
      return;
    }
    this.open = true;
  }

  private initialCollections() {
    if (this.selectedCollectionIds.length === 0) {
      this.selectedCollections = [];
      return;
    }
    this.indexCollections({ query: { q: { or: { id: this.selectedCollectionIds } }, per_page: this.selectedCollectionIds.length }, workspaceId: this.workspace.id }).then(
      (collections: Collection[]) => {
        const orderedCollections: Collection[] = [];
        this.selectedCollectionIds.map((collectionId) => {
          const foundCollection = collections.find((collection) => collection.id === collectionId);
          if (foundCollection === undefined) {
            return;
          }
          orderedCollections.push(foundCollection);
        });
        this.selectedCollections = orderedCollections;
      },
    );
  }

  private removeCollection(list: Collection[], item: Collection) {
    const index = list.indexOf(item);
    list.splice(index, 1);
    this.updateCollections();
  }

  @Debounce(500)
  private searchCollections() {
    const query: IndexQuery<Collection> = {
      per_page: 20,
    };
    if (this.searchString !== '') {
      query.q = {
        or: {
          name: [`like:*${this.searchString}*`, `match:${this.searchString}`],
        },
      };
    }

    this.indexCollections({ query, workspaceId: this.workspace.id }).then((collections: Collection[]) => {
      this.searchedCollections = collections;
    });
  }

  @Emit('input')
  private updateCollections() {
    this.selectedCollectionIds = this.selectedCollections.map((collection) => collection.id ?? 0);
    return this.selectedCollectionIds;
  }

  @Watch('value', { immediate: true })
  private onValueChanged(val: number[]) {
    this.selectedCollectionIds = val;
  }

  @Watch('searchString')
  private onSearchChanged(val: string) {
    this.searchCollections();
  }

  @Watch('open')
  private onOpenChanged(val: boolean) {
    if (val) {
      if (this.searchedCollections.length === 0) {
        this.searchCollections();
      }
      // @ts-ignore
      this.$refs.input.$refs.input.focus();
    } else {
      this.searchString = '';
    }
  }
}
